(function ($) {

    $(document).ready(function () {

        //HOME flex slider

        $('.slider-wrapper').flickity({
            autoPlay: false,
            draggable: true,
            cellSelector: '.slide',
            prevNextButtons: false,
            cellAlign: 'center',
            wrapAround: true,
            contain: true,
            pageDots: false,
            adaptiveHeight: false,
        });


		//WHAT THEY SAY flex slider
		var review_options = {
			autoPlay: 3000,
            draggable: true,
            cellSelector: '.slide',
            cellAlign: 'center',
            wrapAround: true,
            contain: true,
            adaptiveHeight: false,
		}

		var slides = $('.slider-review-wrapper .slide').length;

		if ( matchMedia('screen and (min-width: 1750px)').matches && slides < 4 ) {
			review_options.wrapAround = false;
			review_options.draggable = false;
			review_options.autoPlay = false;
			review_options.prevNextButtons = false;
			review_options.pageDots = false;
		}

        $('.slider-review-wrapper').flickity( review_options );

    });

})
(jQuery);